import React, { Fragment, useState } from 'react';
import { Btn, H5 } from '../../../../AbstractElements';
import { Card, CardBody, Col, Input, Label, Collapse, CardHeader } from 'reactstrap';
import { AllSkills, Angularjs, GulpPug, htmlcss, Javascript, Nodejs, SpecificSkills } from '../../../../Constant';
import { ChevronDown, ChevronUp } from 'react-feather';

const SkillClass = () => {
  const [isFilter, setIsFilter] = useState(true);
  return (
    <Fragment>
      <Col xl='12'>
        <Card>
          <CardHeader>
            <H5 className='mb-0 p-0'>
              <Btn className='btn btn-link accordion-icon' onClick={() => setIsFilter(!isFilter)} color='transperant'>
                {SpecificSkills}
                {isFilter ? <ChevronUp /> : <ChevronDown />}
              </Btn>
            </H5>
          </CardHeader>
          <Collapse isOpen={isFilter}>
            <CardBody className='animate-chk'>
              <Label className='d-block' for='chk-ani21'>
                <Input className='checkbox_animated' id='chk-ani21' type='checkbox' />
                {htmlcss}
              </Label>
              <Label className='d-block' for='chk-ani22'>
                <Input className='checkbox_animated' id='chk-ani22' type='checkbox' />
                {Javascript}
              </Label>
              <Label className='d-block' for='chk-ani23'>
                <Input className='checkbox_animated' id='chk-ani23' type='checkbox' />
                {Nodejs}
              </Label>
              <Label className='d-block' for='chk-ani24'>
                <Input className='checkbox_animated' id='chk-ani24' type='checkbox' />
                {GulpPug}
              </Label>
              <Label className='d-block mb-0' for='chk-ani25'>
                <Input className='checkbox_animated' id='chk-ani25' type='checkbox' />
                {Angularjs}
              </Label>
            </CardBody>
            <Btn className='btn btn-block text-center' color='primary' type='button'>
              {AllSkills}
            </Btn>
          </Collapse>
        </Card>
      </Col>
    </Fragment>
  );
};

export default SkillClass;
